import React from "react"
import { Box, Link as ChakraLink } from "@chakra-ui/layout"
import { Accordion } from "@chakra-ui/accordion"

import Subheading from "../../../shared/text/subheading"
import SectionHeading from "../../../shared/text/heading"
import ResponsiveBlock from "~components/shared/layout/responsive-block"
import QuestionItem from "./question"
import { Link } from "gatsby"

interface Props {
    notOnHome?: boolean
}

export default function FAQSection({ notOnHome }: Props) {
    return (
        <Box id="faq" pt={{ base: 0, "2xl": notOnHome ? 0 : 16 }}>
            <Box bg="gray.50">
                <ResponsiveBlock pt={24} pb={24}>
                    <SectionHeading
                        color="brand.500"
                        fontWeight="black"
                        textAlign="center"
                        mb={4}
                    >
                        FAQs
                    </SectionHeading>
                    <Subheading textAlign="center" fontSize="xl">
                        Questions we're asked most often
                    </Subheading>
                    <Accordion mt={12} defaultIndex={[]} allowMultiple>
                        <QuestionItem question="What happened to Chckup?">
                            We're still here! We rebranded from Chckup to
                            Chckvet in January of 2025. We are still the same
                            team, with the same great product.
                        </QuestionItem>
                        <QuestionItem question="Our schedule is complicated/different/weird - will this work for my practice?">
                            When we say Chckvet is fully customizable to your
                            practice, we mean it. There is no situation we can't
                            handle.
                        </QuestionItem>
                        <QuestionItem question="What is the process like once I sign up?">
                            Our onboarding process has 3 primary parts:
                            <br />
                            <br />
                            <ol>
                                <li>The Initial Sync</li>
                                <span>
                                    We'll setup your practice to sync with our
                                    system. Initial setup takes 15 minutes.
                                </span>
                                <br />
                                <br />
                                <li>Onboarding Call</li>
                                <span>
                                    After your practice is synced, we'll set up
                                    your communication preferences, scheduling
                                    rules, reminders, confirmations, etc live
                                    with you.
                                </span>
                                <br />
                                <br />
                                <li>Widget Install & Going Live</li>
                                <span>
                                    Once we fully customize Chckvet to your
                                    practice, all that's left is to install the
                                    scheduling/chat widgets on your website,
                                    social media, etc. & turn on your
                                    notifications. Then you'll be live & ready
                                    to start saving time & growing your
                                    practice.
                                </span>
                            </ol>
                        </QuestionItem>
                        <QuestionItem question="Who is Chckvet for?">
                            Chckvet is for any practice that is looking to
                            provide a better experience for both their practice
                            staff & pet owners.
                            <br />
                            <br />
                            Chckvet also is only for practices that use a
                            compatible PIMS that we are integrated with. To see
                            which systems we work with, please refer to the{" "}
                            <ChakraLink
                                as={Link}
                                to="/pims"
                                textDecoration="underline"
                                color="brand.600"
                            >
                                systems we work with page
                            </ChakraLink>
                            .
                        </QuestionItem>
                        {!notOnHome && (
                            <QuestionItem question="How does Chckvet compare to competitors?">
                                If you'd like to learn more about how Chckvet
                                compares to competitors, check out our{" "}
                                <ChakraLink
                                    as={Link}
                                    to="/compare"
                                    textDecoration="underline"
                                    color="brand.600"
                                >
                                    comparison pages.
                                </ChakraLink>
                            </QuestionItem>
                        )}
                        <QuestionItem question="How much does Chckvet cost?">
                            We charge $299 per month per location with a
                            one-time setup fee of $990 per location. All
                            contracts are month to month an you can cancel any
                            time.
                        </QuestionItem>
                        <QuestionItem question="Is there a refund policy?">
                            We currently offer a 90-day money back guarantee. If
                            for some reason you are unsatisfied with Chckvet
                            within 90 days of signing a contract with us, we
                            will refund you your money.
                            <br />
                            <br />
                            This is also contingent on the practice onboarding
                            in a reasonable time frame.
                        </QuestionItem>
                        <QuestionItem question="Do you sell my data?">
                            We will{" "}
                            <strong>
                                <u>
                                    <i>never</i>
                                </u>{" "}
                            </strong>
                            sell your data.
                        </QuestionItem>
                    </Accordion>
                </ResponsiveBlock>
            </Box>
        </Box>
    )
}
